<template>
  <div class="input-wrapper">
    <input
      class="input"
      :class="{
        input_clearable: clearable,
        input_error: error
      }"
      v-model="localValue"
      :placeholder="placeholder"
      :readonly="readonly"
      @input="onInput"
    />

    <button
      v-if="clearable && localValue"
      class="clear"
      @click="modelValue = ''"
    >
      <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
        <path d="m6.8955 5 2.8429-2.8429c0.34886-0.34886 0.34886-0.91449 0-1.2636l-0.63182-0.63182c-0.34886-0.34886-0.91449-0.34886-1.2636 0l-2.8429 2.8429-2.8429-2.8429c-0.34886-0.34886-0.91449-0.34886-1.2636 0l-0.63182 0.63182c-0.34886 0.34886-0.34886 0.91449 0 1.2636l2.8429 2.8429-2.8429 2.8429c-0.34886 0.34886-0.34886 0.91449 0 1.2636l0.63182 0.63182c0.34886 0.34886 0.91477 0.34886 1.2636 0l2.8429-2.8429 2.8429 2.8429c0.34886 0.34886 0.91477 0.34886 1.2636 0l0.63182-0.63182c0.34886-0.34886 0.34886-0.91449 0-1.2636l-2.8429-2.8429z"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  props: {
    value: String,
    debounce: Number,
    clearable: Boolean,
    placeholder: String,
    error: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      localValue: '',
    };
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    setOnInput() {
      this.onInput = debounce((e) => {
        this.modelValue = e.target.value;
      }, this.debounce);
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.localValue = newValue;
      },
      immediate: true,
    },
  },
  created() {
    this.setOnInput();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.input-wrapper {
  position: relative;
}

.input {
    background: var(--tertiary-bg);
    border: 1px solid var(--tertiary-accent);
    border-radius: 2px;
    padding: 6px;
    font-size: 14px;
    font-family: "IBM Plex Sans", sans-serif;
    color: var(--text-primary);
    height: 100%;
    width: 100%;

    &_clearable {
      padding-right: 25px;

      @include notebook {
        padding-right: 30px;
      }
    }

    &_error {
      border-color: var(--text-error);
      background-color: var(--bg-error);
    }

    @include notebook {
      font-size: 16px;
    }

    &::placeholder {
        font-family: "IBM Plex Sans", sans-serif;
        color: var(--text-primary);
    }
}

.clear {
  position: absolute;
  top: 1px;
  bottom: 0;
  right: 10px;
  width: fit-content;
  height: fit-content;
  fill: #708090;
  margin: auto;

  @include notebook {
    padding: 10px;
    right: 0;
  }

  svg {
    width: 10px;
    height: 10px;
  }
}
</style>
